import { CleanHands, Favorite, FavoriteBorder, UTurnLeft } from "@mui/icons-material";
import { CircularProgress, Divider, TabPanel } from "@mui/joy";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../Shared/CustomButton";
import CustomDiv from "../../../Shared/CustomDiv";
import CustomTextField from "../../../Shared/CustomTextField";
import Text from "../../../Shared/Text";
import Slider from "react-slick";
import { Link, useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { API_URLS } from "../../../Config/API_URLS";
import axiosInstance from "../../../Config/axios";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import { checkPincodeFn } from "../../../Services/CheckPincode";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

const ProductPage = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  const { id } = useParams();
  const [thumbnail, setThumbnail] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(false);
  const [tab, setTab] = useState("Description");
  const [variantColor, setVariantColor] = useState("None");
  const [variantStorage, setVariantStorage] = useState("None");
  const [variant, setVariant] = useState("None");
  const [pincode, setPincode] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [mostViewedProductss, setMostViewedProductss] = useState([]);
  const [topRatedProductss, setTopRatedProductss] = useState([]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const mostViewedProduct = () => {
    axiosInstance
      .post(API_URLS.mostViewedProducts)
      .then((response) => {
        setMostViewedProductss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
  };

  const navigate = useNavigate();

  const handleThaumbnailClick = (src) => {
    setThumbnail(src);
  };

  const productDetailData = () => {
    setIsLoading(true);
    axiosInstance
      .post(
        `api/product-deatils/?variant_color_value_id=${variantColor}&variant_storage_value_id=${variantStorage}&other_variants_value_id=${variant}`,
        { id: id }
      )
      .then((response) => {
        setIsLoading(false);
        setDetail(response.data.data[0].product_deatils[0]);
        setData(response.data.data[0].related_products);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const client = useQueryClient();
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const handleWishList = (variant_id, event) => {
    event.stopPropagation();
    const reqBody = {
      add_quantity: 1,
      product_id: variant_id,
    };

    axiosInstance
      .post(API_URLS.addToWishList, reqBody)
      .then((response) => {
     
       alert( response.data.msg )
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const topRatedProduct = () => {
    axiosInstance
      .post(API_URLS.topRatedProducts)
      .then((response) => {
        setTopRatedProductss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(
    () => {
      productDetailData();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    // eslint-disable-next-line
    [variantColor, variantStorage, id]
  );

  const emptyFunction = () => {};
  const { mutate } = useMutation(checkPincodeFn, {
    onSuccess: (response) => {
      response.data.response_code === 200
        ? setDelivery(
            `Delivery within ${response.data.delivery_time} in ${response.data.city_name}`
          )
        : emptyFunction();
    },
  });

  useEffect(
    () => {
      pincode.length === 6 ? mutate({ zipcode: pincode }) : emptyFunction();
    },
    // eslint-disable-next-line
    [pincode]
  );
  useEffect(() => {
    mostViewedProduct();
    topRatedProduct();
  }, []);
  console.log("data",data)

  return isLoading ? (
    <>
      <CustomDiv className="flex h-[90vh] justify-center items-center">
        <CircularProgress size="lg" color="primary" />
      </CustomDiv>
    </>
  ) : (
    <CustomDiv className="flex flex-col overflow-x-hidden bg-gray-100  shadow px-[2%] lg:px-[8%] py-[4%] w-full">
      <CustomDiv className="flex lg:flex-row flex-col w-full bg-white ">
        <CustomDiv className="flex flex-col justify-center lg:w-[40%]">
          <span className="centerdiv flex-col w-full">
            <img
              src={
                thumbnail
                  ? thumbnail
                  : detail?.product_variant_value_list?.[0]
                      ?.varients_multiple_image?.[0]?.variant_image
              }
              alt=""
              className="h-[380px] w-[380px] rounded p-2"
            />
          </span>
         

          <CustomDiv className="lg:px-8 px-4 pb-3">
            <Slider {...settings} className="home-slider">
              {detail?.product_variant_value_list?.[0]?.varients_multiple_image?.map(
                (item) => {
                  return (
                    <CustomDiv
                      className="cursor-pointer"
                      onClick={() => {
                        handleThaumbnailClick(item.variant_image);
                      }}
                    >
                      <img
                        src={item.variant_image}
                        alt=""
                        className={classNames(
                          "p-1 border border-zinc-200 ",
                          item.variant_image === thumbnail
                            ? "border-zinc-400"
                            : ""
                        )}
                      />
                    </CustomDiv>
                  );
                }
              )}
            </Slider>
          </CustomDiv>
        </CustomDiv>
        <Divider orientation="vertical" />
        <CustomDiv className="flex flex-col min-h-fit lg:w-[60%] justify-center">
          <CustomDiv className="flex flex-col px-1 gap-3 w-full">
            <Text className="lg:text-xl text-lg font-semibold">
              {detail?.product_variant_value_list?.[0]?.variant_name}
            </Text>
            <Text>{detail?.sub_category}</Text>
            <span className="flex lg:gap-2">
            {/* <IconButton
              color="primary"
              variant="solid"
              onClick={(event) => {
                localStorage.getItem("shubhgatoken") ? (
                  detail.whishlist_status === "yes" ? (
                    <>{` ${enqueueSnackbar("Product is already in wishlist")}
                            ${event.stopPropagation()}`}</>
                  ) : (
                    handleWishList(detail?.variant_id, event)
                  )
                ) : (
                  handleLogin(event)
                );
              }}
              className="!rounded !bg-[#306BDE] scale-90 lg:scale-100"
            >
              {detail.whishlist_status === "yes" ? (
                <Favorite />
              ) : (
                <FavoriteBorder />
              )}
            </IconButton> */}
          </span>
            {/* <span className="flex items-center gap-2">
              <Text
                className={
                  detail?.product_variant_value_list?.[0]?.stock_sataus ===
                  "In-stock"
                    ? "text-green-600 text-lg font-semibold"
                    : "text-red-600 text-lg font-semibold"
                }
              >
                {detail?.product_variant_value_list?.[0]?.stock_sataus}
              </Text>
              <Text className="text-sm">(Product HSN : {detail?.HSN})</Text>
            </span> */}

            {/* <Text className="uppercase">
              {detail?.variant_color?.[0]?.title}
            </Text> */}
            {/* <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] hide-scroll">
              {detail?.variant_color_value?.map((color) => {
                return (
                  <CustomDiv
                    className={classNames(
                      "flex flex-col cursor-pointer border-[3px] transition-all duration-300 p-2 rounded",
                      detail?.product_variant_value_list?.[0]
                        ?.color_variant_values_id === color.id
                        ? "border-gray-800 rounded-lg"
                        : "border-gray-200 rounded-lg"
                    )}
                    onClick={() =>
                      detail?.product_variant_value_list?.[0]
                        ?.color_variant_values_id === color.id
                        ? null
                        : setVariantColor(color.id)
                    }
                  >
                    <Text>{color.color}</Text>
                  </CustomDiv>
                );
              })}
            </CustomDiv> */}
            <Text className="uppercase">
              {detail?.variant_storage?.[0]?.title}
            </Text>
            {/* <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] hide-scroll">
              {detail?.variant_storage_value?.map((storage) => {
                return (
                  <CustomDiv
                    className={classNames(
                      "flex flex-col cursor-pointer border-[3px] transition-all duration-300 p-2 rounded",
                      detail?.product_variant_value_list?.[0]
                        ?.storage_variant_values_id === storage.id
                        ? "border-gray-800 rounded-lg"
                        : "border-gray-200 rounded-lg"
                    )}
                    onClick={() =>
                      detail?.product_variant_value_list?.[0]
                        ?.storage_variant_values_id === storage.id
                        ? null
                        : setVariantStorage(storage.id)
                    }
                  >
                    <Text>{storage.value}</Text>
                  </CustomDiv>
                );
              })}
            </CustomDiv> */}
            {/* <Text className="uppercase">
              {detail?.other_variants?.[0]?.title}
            </Text> */}

            {/* <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] hide-scroll">
              {detail?.other_variants_value?.map((ram) => {
                return (
                  <CustomDiv
                    className={classNames(
                      "flex flex-col cursor-pointer border-[3px] transition-all duration-300 p-2 rounded",
                      detail?.product_variant_value_list?.[0]
                        ?.other_variant_values_id === ram.id
                        ? "border-gray-800 rounded-lg"
                        : "border-gray-200 rounded-lg"
                    )}
                    onClick={() =>
                      detail?.product_variant_value_list?.[0]
                        ?.other_variant_values_id === ram.id
                        ? null
                        : setVariant(ram.id)
                    }
                  >
                    <Text>{ram.value}</Text>
                  </CustomDiv>
                );
              })}
            </CustomDiv> */}
            <div className="flex ">
              <Text className="text-lg ">
                <span className="font-bold text-xl mx-2">
                  ₹{detail?.product_variant_value_list?.[0]?.actual_price}
                </span>
                MRP
                <span className="line-through mx-2 ">
                  ₹{detail?.product_variant_value_list?.[0]?.variant_price}
                </span>
                <span className="text-green-600 ">
                  Save
                  <span className="mx-2">
                    {Number(detail?.discount_percent)}%
                  </span>
                </span>
              </Text>
             
            </div>
            <span className="mx-1">
                {detail?.product_variant_value_list?.[0]
                  ?.is_subscription_active ? (
                  <CustomButton
                    className="!rounded-none   !font-bold"
                    variant="outlined"
                    onClick={() =>
                      navigate(
                        `/plan/${detail?.product_variant_value_list?.[0]?.variant_id}`
                      )
                    }
                  >
                    Subscribe
                  </CustomButton>
                ) : (
                  <CustomButton
                    className="!rounded-none !font-bold "
                    variant="outlined"
                    onClick={(event) =>
                      localStorage.getItem("shubhgatoken")
                        ? addToCart(
                            event,
                            detail?.product_variant_value_list?.[0]?.variant_id
                          )
                        : handleLogin()
                    }
                  >
                    +Add
                  </CustomButton>
                )}
              </span>

            {/* <CustomDiv className="flex flex-col lg:flex-row items-center lg:px-10 justify-around gap-2 my-2 w-full">
              <Divider orientation="vertical" />
              <span className="flex flex-col gap-4 w-full lg:!w-auto py-6">
                <Text>Delivery Options</Text>
                <CustomTextField
                  type="number"
                  className="!rounded-none !w-full lg:!w-auto"
                  placeholder="Enter Pincode"
                  onChange={(event) => setPincode(event.target.value)}
                />
                <Text>{delivery}</Text>
              </span>
            </CustomDiv> */}
          </CustomDiv>

          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Tabs
              orientation="horizontal"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              <Tab label="Details" {...a11yProps(0)} />
              <Tab label="Other info" {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={value} index={0}>
              <p className="text-left text-green-600">
                MRP ₹ 1500 (all inclusive taxes)
              </p>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <p className="text-left text-red-600">
                Best Product - with Best discount
              </p>
            </TabPanel>
          </Box>
          <div>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="!font-bold">
                  Product Description
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CustomDiv className="bg-white  shadow flex flex-col">
                  {/* <CustomDiv className="flex gap-3 px-2">
                    {["Description"].map((item) => {
                      return (
                        <Link onClick={() => setTab(item)} to="#">
                          <Text
                            className={classNames(
                              "border-b-2 border-red-500 border-opacity-0 hover:border-opacity-100 p-2",
                              tab === item
                                ? "!border-opacity-100 !text-red-500"
                                : ""
                            )}
                          >
                            {item}
                          </Text>
                        </Link>
                      );
                    })}
                  </CustomDiv> */}
                  <Divider />
                  <CustomDiv>
                    {tab === "Description" ? (
                      <Text className="p-5">{detail?.description}</Text>
                    ) : tab === "Ingredients" ? (
                      <Text className="p-5">
                        Ingredients : Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Dicta, mollitia! Veritatis repellat
                        maiores blanditiis corporis, non maxime placeat soluta
                        incidunt a suscipit fuga voluptatum ducimus architecto
                        ipsum eveniet error deleniti?
                      </Text>
                    ) : (
                      <Text className="p-5">
                        How To Use : Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Dicta, mollitia! Veritatis repellat
                        maiores blanditiis corporis, non maxime placeat soluta
                        incidunt a suscipit fuga voluptatum ducimus architecto
                        ipsum eveniet error deleniti?
                      </Text>
                    )}
                  </CustomDiv>
                </CustomDiv>
              </AccordionDetails>
            </Accordion>
          </div>
        </CustomDiv>
      </CustomDiv>
      <div>
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Recent Products
        </p>
      </div>
      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {data.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.product_image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.variant_name}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            {product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                    <Text className="text-green-600">
                      {product.discount_percent !== "0.0"
                        ? `(${product.discount_percent?.split(".0")})% OFF`
                        : null}
                    </Text>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    onClick={(event) =>
                      localStorage.getItem("shubhgatoken")
                        ? addToCart(
                            event,
                            detail?.product_variant_value_list?.[0]?.variant_id
                          )
                        : handleLogin()
                    }
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>

      <div>
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Most Viewed Products
        </p>
      </div>
      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {mostViewedProductss?.product_list?.slice(0, 9)?.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.title}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            ₹{product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>
      <div>
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Top Rated Products
        </p>
      </div>
      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {topRatedProductss?.product_list?.slice(0, 9)?.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.title}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            ₹{product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>
    </CustomDiv>
  );
};

export default ProductPage;
